import React from 'react';
import SnakeAnim from './SnakeAnim';

const TestSnaking = ({isData, startAnimation, data, positions, type, tme}) => {
    
        if(isData){
            return ( <SnakeAnim startAnimation={startAnimation} tme={tme} type={type} data={data} positions={positions} />)
        }else{
            return null;
        }      
};

export default TestSnaking;